import { render } from "./Index.vue?vue&type=template&id=b0f63c02"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/Coupon8/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0f63c02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0f63c02', __exports__)) {
    api.reload('b0f63c02', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=b0f63c02", () => {
    api.rerender('b0f63c02', render)
  })

}


export default __exports__